import type {ModuleEnum, TaskDefinitionResponse} from 'src/api/ProactApiClient';
import {FormTransitionBar} from 'src/app/forms/FormTransitionBar';
import {TaskFeatureDefinitionView} from 'src/app/tasks/TaskFeatureViews';
import {ApiEndpoints} from 'src/shared/constants/apiEndpoints';
import {useStateMachine} from 'src/shared/hooks/api/useStateMachine';

export interface TaskContentsProps {
  module: ModuleEnum;
  item?: TaskDefinitionResponse;
  onRefreshTransition: () => void;
}
const TaskContents: React.FC<TaskContentsProps> = ({
  module,
  item,
  onRefreshTransition,
}) => {
  const [machine] = useStateMachine({
    url: ApiEndpoints.getTaskDefinitionStateMachine,
  });

  return (
    <>
      {item && <TaskFeatureDefinitionView item={item} />}
      {machine && item && item.locked === false && (
        <FormTransitionBar
          module={module}
          stateMachine={machine}
          stateId={item.state}
          transitionBaseUrl={`task-definition/${item.id}/transition`}
          onRefreshTransition={onRefreshTransition}
          objectType={item?.taskType}
          invalidateTagsOnComplete={['TaskDefinitions', 'TaskAssignments']}
        />
      )}
    </>
  );
};

export default TaskContents;
